import { ReactText } from 'react'
import { Layer } from 'modules/shares/types'
import { capitalize } from '@sketch/utils'

interface Args {
  radius: ReactText
  style: Layer['cornerStyle']
}

const copy = ({ radius, style }: Args) =>
  `Radius: ${radius}${style ? `\nStyle: ${capitalize(style)}` : ''}`

export default copy
